export const COMMON_SHIFT_EVENT_WIDGET_NAMESPACE = 'widget.common-shift-event'
